/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-28 14:53:00
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-09-14 16:40:44
 * @name: 商品管理api
 * @Description: 商品管理api
 * @FilePath: \preSaleNafterSaleBackstage\src\api\goodsManage\goods.api.js
 * @Author: DESKTOP-1QU67QM
 */
import apiAdd from "../apiAdd.js";
import apiEdit from "../apiEdit.js";
import apiDelete from "../apiDelete.js";
import apiSearch from "../apiSearch.js";
import axios from 'axios';
import { Message } from "element-ui";
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取品牌系列型号表格数据
 * @param {Object} data -> {
 *                    parent_id{Number | undefined}: 父级id
 *                 }
 */
export const categoryGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/category/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取品牌系列型号表格数据
 * @param {Object} data -> {category_id{String}: 分类id}
 */
export const categoryDetail = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/category/detail.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 添加商品分类
 * @param {Object} data -> {
 *                    name{String}: 名称,
 *                    status{Number}: 状态,
 *                    parent_id{Number | undefined}: 父级ID,
 *                 }
 */
export const categoryAdd = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  try {
    if (!data.name) {
      throw '请输入类型名称!';
    }
    return apiAddInstance.post('/admin/category/add.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 编辑商品分类
 * @param {Object} data -> {
 *                    category_id{Number}: 分类ID,
 *                    name{String}: 名称,
 *                    status{Number}: 状态,
 *                    parent_id{Number | undefined}: 父级ID,
 *                 }
 */
export const categoryEdit = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  try {
    if (!data.name) {
      throw '请输入类型名称!';
    }
    return apiEditInstance.post('/admin/category/edit.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 删除商品分类
 * @param {Object} data -> {
 *                    category_id{Number}: 分类ID,
 *                 }
 */
export const categoryDelete = (data) => {
  const instance = axios.create();
  const apiDeleteInstance = new apiDelete();
  return apiDeleteInstance.post('/admin/category/delete.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 切换商品分类显示状态
 * @param {Object} data -> {
 *                    category_id{Number}: 分类ID,
 *                    status{Number}: 是否显示,1=>是,2=>否,
 *                 }
 */
export const categoryChangeStatus = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  return apiEditInstance.post('/admin/category/change_status.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取颜色列表
 */
export const colorGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/color/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取规格列表
 * @param {String} spec_id 规格id
 */
export const specGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/spec/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取所有型号
 */
export const categoryGetAllThirdlevelList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/category/getAllThirdlevelList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 商品列表
 * @param {Object} data -> {
 *                    goods_id{String}: 商品id
 *                    goods_name{String}: 商品名称
 *                    color_id{String}: 颜色id
 *                    category_id{String}: 分类id
 *                    status{String}: 是否显示 1=> 显示, 2=> 隐藏
 *                 }
 */
export const goodsGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/goods/getList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 添加商品
 * @param {Object} data -> {
 *                    category_id{Number}: 分类id
 *                    goods_name{String}: 商品名称
 *                    color_id{Number}: 颜色id
 *                    price{Number}: 价格
 *                    stock{Number}: 库存
 *                    file_id{Number}: 图片文件id
 *                    status{Number}: 状态
 *                    goods_level: 商品级别{Array} [] -> { level{Number}: 级别数,price{Number}: 价格 }
 *                 }
 */
export const goodsAdd = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  try {
    if (!data.category_id) {
      throw '请选择产品型号!';
    }
    if (!data.goods_name) {
      throw '请输入产品名称!';
    }
    if (!data.color_id) {
      throw '请选择产品颜色!';
    }
    if (!data.price || isNaN(data.price) || Number(data.price) < 0) {
      throw '请输入正确的产品价格!';
    }
    if (!data.stock || isNaN(data.stock) || Number(data.stock) < 0) {
      throw '请输入正确的产品库存!';
    }
    if (!data.file_id) {
      throw '请上传产品图片!';
    }
    if (data.goods_level.findIndex(x => !x.level) > -1) {
      throw '每一级均须选择级别!';
    }
    if (data.goods_level.findIndex(x => !x.price || isNaN(x.price) || Number(x.price) < 0) > -1) {
      throw '每一级均须输入正确的价格!';
    }
    return apiAddInstance.post('/admin/goods/add.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 编辑商品
 * @param {Object} data -> {
 *                    goods_id{Number}: 商品id
 *                    category_id{Number}: 分类id
 *                    goods_name{String}: 商品名称
 *                    color_id{Number}: 颜色id
 *                    price{Number}: 价格
 *                    stock{Number}: 库存
 *                    file_id{Number}: 图片文件id
 *                    status{Number}: 状态
 *                    goods_level{Array}: 商品级别 [] -> { level{Number}: 级别数,price{Number}: 价格 }
 *                 }
 */
export const goodsEdit = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  try {
    if (!data.category_id) {
      throw '请选择产品型号!';
    }
    if (!data.goods_name) {
      throw '请输入产品名称!';
    }
    if (!data.color_id) {
      throw '请选择产品颜色!';
    }
    if (!data.price || isNaN(data.price) || Number(data.price) < 0) {
      throw '请输入正确的产品价格!';
    }
    if (!data.stock || isNaN(data.stock) || Number(data.stock) < 0) {
      throw '请输入正确的产品库存!';
    }
    if (!data.file_id) {
      throw '请上传产品图片!';
    }
    if (data.goods_level.findIndex(x => !x.price || isNaN(x.price) || Number(x.price) < 0) > -1) {
      throw '每一级均须输入正确的价格!';
    }
    return apiEditInstance.post('/admin/goods/edit.html', data, instance);
  } catch (error) {
    Message.error(error);
    return Promise.reject({ code: 'request:error', data: null, msg: error });
  }
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 删除商品
 * @param {Object} data -> {
 *                    goods_id{Number}: 商品id
 *                 }
 */
export const goodsDelete = (data) => {
  const instance = axios.create();
  const apiDeleteInstance = new apiDelete();
  return apiDeleteInstance.post('/admin/goods/delete.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 切换商品显示状态
 * @param {Object} data -> {goods_id{Number}: 商品id,status{Number}: 状态}
 */
export const goodsChangeStatus = (data) => {
  const instance = axios.create();
  const apiEditInstance = new apiEdit();
  return apiEditInstance.post('/admin/goods/change_status.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 全部琴行
 * @param {Object} data -> {goods_private_sku_id{Number}: 商品私有sku主键id}
 */
export const agencyGoodsGetAllList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/agency_goods/getAllList.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 添加琴行
 * @param {Object} data -> {goods_level_id{Number}: 商品级别主键id,agency_ids{String}: 琴行id字符串}
 */
export const agencyGoodsAdd = (data) => {
  const instance = axios.create();
  const apiAddInstance = new apiAdd();
  return apiAddInstance.post('/admin/agency_goods/add.html', data, instance);
}
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 删除琴行
 * @param {Object} data -> {agency_goods_id{Number}: 琴行商品主键id}
 */
export const agencyGoodsDelete = (data) => {
  const instance = axios.create();
  const apiDeleteInstance = new apiDelete();
  return apiDeleteInstance.post('/admin/agency_goods/delete.html', data, instance);
}